import React, { useEffect } from 'react';
import classnames from 'classnames';
import { ModalBody, ModalBodyProps } from '../modal/modal-body';
import { useDialogContext } from './dialog-context-provider';

export type DialogBodyProps = ModalBodyProps;

export const DialogBody = ({ className, ...props }: DialogBodyProps): React.ReactElement => {
  const classNames = classnames(className, 'airtame-dialog__body');
  const { disableLegacy } = useDialogContext();
  useEffect(() => disableLegacy(), []);

  return <ModalBody {...props} className={classNames} />;
};
